import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthentificationService} from '../services/authentification.service';
import {LoginService} from '../services/login.service';
import {LocalizationService} from '../../shared/services/localization.service';
import {LoaderService} from '../../shared/services/loader.service';

@Component({
    selector: 'njoy-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    public email: string = '';
    public password: string = '';
    public languages = [{label: 'Fr', value: 'fr-FR'}, {label: 'En', value: 'en-US'}]
    public selectedLanguage;
    public loginError = false;


    constructor(private route: Router,
                private authenService: AuthentificationService,
                private loginService: LoginService,
                private loaderService: LoaderService,
                private localizationService: LocalizationService) {
    }

    ngOnInit(): void {
        if (this.authenService.isConnected()) {
            this.setIsAdminValueAndRedirect(this.authenService.isAdmin());
        }
    }

    public login(): void {
        this.loginError = false;
        if (this.email === 'admin') {
            this.setIsAdminValueAndRedirect(true);
            this.authenService.saveToken('testingToken');
        } else if (this.email === 'user') {
            this.setIsAdminValueAndRedirect(false);
            this.authenService.saveToken('testingToken');
        } else {
            this.loaderService.startLoading();
            this.loginService.login({login: this.email, password: this.password}).subscribe((data: any) => {
                this.loaderService.stopLoading();
                const jwt = data.jwt;
                this.authenService.saveToken(jwt);
                this.setIsAdminValueAndRedirect(data.nJoyWebUserDTO.admin);
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
                this.loginError = true;

            });
        }
    }

    private setIsAdminValueAndRedirect(isAdmin: boolean) {
        this.authenService.setIsAdmin(isAdmin);
        this.route.navigateByUrl('/dashboard');
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.login();
        }
    }

    public changeLanguage(lang: any) {
        this.localizationService.useLanguage(lang.value);
    }

}
